import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from './firebase'; // Adjust the import path if necessary
import { getAuth } from 'firebase/auth';
import './Details.css';

const Details = () => {
    const { id } = useParams();
    const [vehicle, setVehicle] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [quantity, setQuantity] = useState(1);

    const auth = getAuth();
    const userId = auth.currentUser ? auth.currentUser.uid : null;

    useEffect(() => {
        const fetchVehicle = async () => {
            try {
                const vehicleDocRef = doc(db, 'vehicles', id);
                const vehicleDoc = await getDoc(vehicleDocRef);

                if (vehicleDoc.exists()) {
                    setVehicle(vehicleDoc.data());
                } else {
                    setError('Vehicle not found.');
                }
            } catch (err) {
                console.error('Error fetching vehicle:', err);
                setError('Failed to fetch vehicle details.');
            } finally {
                setLoading(false);
            }
        };

        fetchVehicle();
    }, [id]);

    const handleQuantityChange = (e) => {
        const value = parseInt(e.target.value, 10);
        if (value >= 0 && value <= 5) {
            setQuantity(value);
        }
    };

    const handleBuy = async () => {
        if (userId) {
            const cartRef = doc(db, `users/${userId}/Cart`, id); // Add vehicle data to user's cart
            try {
                await setDoc(cartRef, {
                    vehicleId: id,
                    name: vehicle.name,
                    model: vehicle.model,
                    price: vehicle.price,
                    quantity: quantity,
                    imageUrl: vehicle.imageUrl
                });
                alert('Vehicle added to cart!');
            } catch (err) {
                console.error('Error adding to cart:', err);
                alert('Failed to add to cart.');
            }
        } else {
            alert('Please sign in to proceed.');
        }
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div className="Details-grid">
            <img src={vehicle.imageUrl} alt={vehicle.name} className="details-image" />
            <div className="details-info">
                <p><label>Vehicle Type: </label> {vehicle.vehicleType}</p>
                <p><label>Name: </label> {vehicle.name}</p>
                <p><label>Model: </label> {vehicle.model}</p>
                <p><label>Price: </label> ₹{vehicle.price}</p>
                <p><label>Description: </label> {vehicle.description}</p>
            </div>
            <div className="details-actions">
                <div className="action-buttons">
                    <label htmlFor="quantity">Quantity: 
                        <input type="number" id="quantity" value={quantity} min="0" max="5" onChange={handleQuantityChange} className="quantity-input" />
                    </label>
                    <span>
                        <button className="buy" >Buy</button>
                        <span>or</span>
                        <button className="cart" onClick={handleBuy}>Add to Cart</button>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default Details;
